import { OldRoute, Route } from "../../types/route.type";
import { defaultMockServiceCenter } from "../serviceCenter/serviceCenters.mocks";

export const mockPresetRoutesAndTraps = {
  empty: [],
  default: [
    {
      id: 200,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: [
        {
          zipCodeId: 1,
          zipCode: "93599",
          shipmentTags: [
            {
              id: 1,
              name: "UC",
              description: "Urgent care shipment",
              colorHex: "#FBC02D",
              position: 1,
            },
            {
              id: 1,
              name: "CC",
              description: "Critical care shipment",
              colorHex: "#EA5E5A",
              position: 1,
            },
          ],
        },
        { zipCodeId: 2, zipCode: "93591", shipmentTags: [] },
        { zipCodeId: 3, zipCode: "93561", shipmentTags: [] },
        { zipCodeId: 4, zipCode: "93555", shipmentTags: [] },
        { zipCodeId: 5, zipCode: "93551", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: "00:00:00",
      trailerId: 884,
      tractorId: 1651,
      equipmentType: 2,
      straightTruckId: null,
      doorId: 1,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ALL FREIGHT",
      hereFeatureId: null,
    },
    {
      id: 594,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 6, zipCode: "HI", shipmentTags: [] },
        { zipCodeId: 7, zipCode: "96898", shipmentTags: [] },
        { zipCodeId: 8, zipCode: "96863", shipmentTags: [] },
        { zipCodeId: 9, zipCode: "96861", shipmentTags: [] },
        { zipCodeId: 10, zipCode: "96860", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      equipmentType: 3,
      straightTruckId: 3,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ALOHA",
      hereFeatureId: null,
    },
    {
      id: 783,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 11, zipCode: "92806", shipmentTags: [] },
        { zipCodeId: 12, zipCode: "92899", shipmentTags: [] },
        { zipCodeId: 13, zipCode: "92850", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ANAHEIM",
      hereFeatureId: null,
    },
    {
      id: 177,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 14, zipCode: "91793", shipmentTags: [] },
        { zipCodeId: 15, zipCode: "91791", shipmentTags: [] },
        { zipCodeId: 16, zipCode: "91790", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "AZUSA",
      hereFeatureId: null,
    },
    {
      id: 546,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 17, zipCode: "91987", shipmentTags: [] },
        { zipCodeId: 18, zipCode: "91980", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BENCHPRO",
      hereFeatureId: null,
    },
    {
      id: 189,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 19, zipCode: "92179", shipmentTags: [] },
        { zipCodeId: 20, zipCode: "92173", shipmentTags: [] },
        { zipCodeId: 21, zipCode: "92158", shipmentTags: [] },
        { zipCodeId: 22, zipCode: "92154", shipmentTags: [] },
        { zipCodeId: 23, zipCode: "92153", shipmentTags: [] },
        { zipCodeId: 24, zipCode: "92143", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BORDER",
      hereFeatureId: null,
    },
    {
      id: 172,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 25, zipCode: "92887", shipmentTags: [] },
        { zipCodeId: 26, zipCode: "92886", shipmentTags: [] },
        { zipCodeId: 27, zipCode: "92885", shipmentTags: [] },
        { zipCodeId: 28, zipCode: "92871", shipmentTags: [] },
        { zipCodeId: 29, zipCode: "92870", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BREA",
      hereFeatureId: null,
    },
    {
      id: 192,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Coast"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 30, zipCode: "90895", shipmentTags: [] },
        { zipCodeId: 31, zipCode: "90749", shipmentTags: [] },
        { zipCodeId: 32, zipCode: "90748", shipmentTags: [] },
        { zipCodeId: 33, zipCode: "90747", shipmentTags: [] },
        { zipCodeId: 34, zipCode: "90746", shipmentTags: [] },
        { zipCodeId: 35, zipCode: "90745", shipmentTags: [] },
        { zipCodeId: 36, zipCode: "90744", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CARSON",
      hereFeatureId: null,
    },
    {
      id: 169,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Coast"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 37, zipCode: "90704", shipmentTags: [] },
        { zipCodeId: 38, zipCode: "90703", shipmentTags: [] },
        { zipCodeId: 39, zipCode: "90702", shipmentTags: [] },
        { zipCodeId: 40, zipCode: "90701", shipmentTags: [] },
        { zipCodeId: 41, zipCode: "90650", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CERRITOS",
      hereFeatureId: null,
    },
    {
      id: 190,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 41, zipCode: "91951", shipmentTags: [] },
        { zipCodeId: 42, zipCode: "91950", shipmentTags: [] },
        { zipCodeId: 43, zipCode: "91947", shipmentTags: [] },
        { zipCodeId: 44, zipCode: "91913", shipmentTags: [] },
        { zipCodeId: 45, zipCode: "91911", shipmentTags: [] },
        { zipCodeId: 46, zipCode: "91910", shipmentTags: [] },
        { zipCodeId: 47, zipCode: "91909", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CHULA VISTA",
      hereFeatureId: null,
    },
    {
      id: 549,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Mid"],
      zoneIds: [],
      zipCodes: [
        {
          zipCodeId: 267644,
          zipCode: "91006",
          shipmentTags: [],
        },
        {
          zipCodeId: 267645,
          zipCode: "91007",
          shipmentTags: [],
        },
        {
          zipCodeId: 267646,
          zipCode: "91008",
          shipmentTags: [],
        },
        {
          zipCodeId: 267647,
          zipCode: "91009",
          shipmentTags: [],
        },
        {
          zipCodeId: 267648,
          zipCode: "91010",
          shipmentTags: [],
        },
        {
          zipCodeId: 267649,
          zipCode: "91016",
          shipmentTags: [],
        },
        {
          zipCodeId: 267650,
          zipCode: "91017",
          shipmentTags: [],
        },
        {
          zipCodeId: 267651,
          zipCode: "91077",
          shipmentTags: [],
        },
        {
          zipCodeId: 267652,
          zipCode: "91731",
          shipmentTags: [],
        },
        {
          zipCodeId: 267653,
          zipCode: "91732",
          shipmentTags: [],
        },
        {
          zipCodeId: 267654,
          zipCode: "91733",
          shipmentTags: [],
        },
        {
          zipCodeId: 267655,
          zipCode: "91734",
          shipmentTags: [],
        },
        {
          zipCodeId: 267656,
          zipCode: "91735",
          shipmentTags: [],
        },
        {
          zipCodeId: 267657,
          zipCode: "91770",
          shipmentTags: [],
        },
        {
          zipCodeId: 267658,
          zipCode: "91771",
          shipmentTags: [],
        },
        {
          zipCodeId: 267659,
          zipCode: "91772",
          shipmentTags: [],
        },
        {
          zipCodeId: 267660,
          zipCode: "91775",
          shipmentTags: [],
        },
        {
          zipCodeId: 267661,
          zipCode: "91776",
          shipmentTags: [],
        },
        {
          zipCodeId: 267662,
          zipCode: "91778",
          shipmentTags: [],
        },
        {
          zipCodeId: 267663,
          zipCode: "91780",
          shipmentTags: [],
        },
      ],
      startTime: "07:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "EL MONTE",
      hereFeatureId: null,
    },
    {
      id: 191,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: [{ zipCodeId: 48, zipCode: "12345", shipmentTags: [] }],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: 1,
      tractorId: 2,
      straightTruckId: null,
      doorId: 0,
      driverId: 3,
      isRoute: true,
      isActive: true,
      name: "DEACTIVATED EQUIPMENT DRIVER",
      hereFeatureId: null,
    },
    {
      id: 193,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: [{ zipCodeId: 41, zipCode: "12345", shipmentTags: [] }],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: 1234,
      tractorId: 5234,
      straightTruckId: null,
      doorId: 0,
      driverId: 555,
      isRoute: true,
      isActive: true,
      name: "UNAVAILABLE EQUIPMENT DRIVER",
      hereFeatureId: null,
    },
    {
      id: 1001,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 100, zipCode: "91340", shipmentTags: [] },
        { zipCodeId: 101, zipCode: "91342", shipmentTags: [] },
        { zipCodeId: 102, zipCode: "91344", shipmentTags: [] },
      ],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "SYLMAR",
      hereFeatureId: null,
    },
    {
      id: 1002,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 103, zipCode: "91401", shipmentTags: [] },
        { zipCodeId: 104, zipCode: "91402", shipmentTags: [] },
        { zipCodeId: 105, zipCode: "91403", shipmentTags: [] },
        { zipCodeId: 106, zipCode: "91405", shipmentTags: [] },
        { zipCodeId: 107, zipCode: "91406", shipmentTags: [] },
      ],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "VAN NUYS",
      hereFeatureId: null,
    },
    {
      id: 1003,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 108, zipCode: "92501", shipmentTags: [] },
        { zipCodeId: 109, zipCode: "92503", shipmentTags: [] },
        { zipCodeId: 110, zipCode: "92505", shipmentTags: [] },
        { zipCodeId: 111, zipCode: "92507", shipmentTags: [] },
      ],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "RIVERSIDE",
      hereFeatureId: null,
    },
    {
      id: 1004,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 112, zipCode: "92373", shipmentTags: [] },
        { zipCodeId: 113, zipCode: "92374", shipmentTags: [] },
        { zipCodeId: 114, zipCode: "92375", shipmentTags: [] },
      ],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "REDLANDS",
      hereFeatureId: null,
    },
    {
      id: 1005,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Mid"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 115, zipCode: "90220", shipmentTags: [] },
        { zipCodeId: 116, zipCode: "90221", shipmentTags: [] },
        { zipCodeId: 117, zipCode: "90222", shipmentTags: [] },
        { zipCodeId: 118, zipCode: "90223", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "COMPTON",
      hereFeatureId: null,
    },
    {
      id: 1006,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Coast"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 119, zipCode: "92647", shipmentTags: [] },
        { zipCodeId: 120, zipCode: "92648", shipmentTags: [] },
        { zipCodeId: 121, zipCode: "92649", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "HUNTINGTON BEACH",
      hereFeatureId: null,
    },
    {
      id: 1007,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Coast"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 122, zipCode: "92660", shipmentTags: [] },
        { zipCodeId: 123, zipCode: "92661", shipmentTags: [] },
        { zipCodeId: 124, zipCode: "92662", shipmentTags: [] },
        { zipCodeId: 125, zipCode: "92663", shipmentTags: [] },
      ],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "NEWPORT BEACH",
      hereFeatureId: null,
    },
    {
      id: 1008,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Mid"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 126, zipCode: "90240", shipmentTags: [] },
        { zipCodeId: 127, zipCode: "90241", shipmentTags: [] },
        { zipCodeId: 128, zipCode: "90242", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "DOWNEY",
      hereFeatureId: null,
    },
    {
      id: 1009,
      sicId: defaultMockServiceCenter.id,
      zones: ["North SD County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 129, zipCode: "92025", shipmentTags: [] },
        { zipCodeId: 130, zipCode: "92026", shipmentTags: [] },
        { zipCodeId: 131, zipCode: "92027", shipmentTags: [] },
        { zipCodeId: 132, zipCode: "92029", shipmentTags: [] },
        { zipCodeId: 133, zipCode: "92030", shipmentTags: [] },
      ],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ESCONDIDO",
      hereFeatureId: null,
    },
    {
      id: 1010,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 134, zipCode: "91701", shipmentTags: [] },
        { zipCodeId: 135, zipCode: "91708", shipmentTags: [] },
        { zipCodeId: 136, zipCode: "91709", shipmentTags: [] },
        { zipCodeId: 137, zipCode: "91710", shipmentTags: [] },
      ],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "RANCHO CUCAMONGA",
      hereFeatureId: null,
    },
    {
      id: 1011,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 138, zipCode: "91301", shipmentTags: [] },
        { zipCodeId: 139, zipCode: "91302", shipmentTags: [] },
        { zipCodeId: 140, zipCode: "91303", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CALABASAS",
      hereFeatureId: null,
    },
    {
      id: 1012,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: [
        { zipCodeId: 141, zipCode: "92602", shipmentTags: [] },
        { zipCodeId: 142, zipCode: "92603", shipmentTags: [] },
        { zipCodeId: 143, zipCode: "92604", shipmentTags: [] },
        { zipCodeId: 144, zipCode: "92606", shipmentTags: [] },
        { zipCodeId: 145, zipCode: "92612", shipmentTags: [] },
        { zipCodeId: 146, zipCode: "92614", shipmentTags: [] },
      ],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "IRVINE",
      hereFeatureId: null,
    },
  ],
} as const satisfies Record<string, Route[]>;

export const oldMockPresetRoutesAndTraps = {
  empty: [],
  default: [
    {
      id: 200,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: ["93599", "93591", "93561", "93555", "93551"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: "00:00:00",
      trailerId: 884,
      tractorId: 1651,
      equipmentType: 2,
      straightTruckId: null,
      doorId: 1,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ALL FREIGHT",
      hereFeatureId: null,
    },
    {
      id: 594,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: ["HI", "96898", "96863", "96861", "96860"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      equipmentType: 3,
      straightTruckId: 3,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ALOHA",
      hereFeatureId: null,
    },
    {
      id: 783,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: ["92806", "92899", "92850"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ANAHEIM",
      hereFeatureId: null,
    },
    {
      id: 177,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: ["91793", "91791", "91790"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "AZUSA",
      hereFeatureId: null,
    },
    {
      id: 546,
      sicId: defaultMockServiceCenter.id,
      zones: [],
      zoneIds: [],
      zipCodes: ["91987", "91980"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BENCHPRO",
      hereFeatureId: null,
    },
    {
      id: 189,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: ["92179", "92173", "92158", "92154", "92153", "92143"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BORDER",
      hereFeatureId: null,
    },
    {
      id: 172,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: ["92887", "92886", "92885", "92871", "92870"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "BREA",
      hereFeatureId: null,
    },
    {
      id: 192,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Coast"],
      zoneIds: [],
      zipCodes: ["90895", "90749", "90748", "90747", "90746", "90745", "90744"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CARSON",
      hereFeatureId: null,
    },
    {
      id: 169,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Coast"],
      zoneIds: [],
      zipCodes: ["90704", "90703", "90702", "90701", "90650"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CERRITOS",
      hereFeatureId: null,
    },
    {
      id: 190,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: ["91951", "91950", "91947", "91913", "91911", "91910", "91909"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CHULA VISTA",
      hereFeatureId: null,
    },
    {
      id: 191,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: ["12345"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: 1,
      tractorId: 2,
      straightTruckId: null,
      doorId: 0,
      driverId: 3,
      isRoute: true,
      isActive: true,
      name: "DEACTIVATED EQUIPMENT DRIVER",
      hereFeatureId: null,
    },
    {
      id: 193,
      sicId: defaultMockServiceCenter.id,
      zones: ["South SD County"],
      zoneIds: [],
      zipCodes: ["12345"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: 1234,
      tractorId: 5234,
      straightTruckId: null,
      doorId: 0,
      driverId: 555,
      isRoute: true,
      isActive: true,
      name: "UNAVAILABLE EQUIPMENT DRIVER",
      hereFeatureId: null,
    },
    {
      id: 1001,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: ["91340", "91342", "91344"],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "SYLMAR",
      hereFeatureId: null,
    },
    {
      id: 1002,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: ["91401", "91402", "91403", "91405", "91406"],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "VAN NUYS",
      hereFeatureId: null,
    },
    {
      id: 1003,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: ["92501", "92503", "92505", "92507"],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "RIVERSIDE",
      hereFeatureId: null,
    },
    {
      id: 1004,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: ["92373", "92374", "92375"],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "REDLANDS",
      hereFeatureId: null,
    },
    {
      id: 1005,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Mid"],
      zoneIds: [],
      zipCodes: ["90220", "90221", "90222", "90223"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "COMPTON",
      hereFeatureId: null,
    },
    {
      id: 1006,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Coast"],
      zoneIds: [],
      zipCodes: ["92647", "92648", "92649"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "HUNTINGTON BEACH",
      hereFeatureId: null,
    },
    {
      id: 1007,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Coast"],
      zoneIds: [],
      zipCodes: ["92660", "92661", "92662", "92663"],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "NEWPORT BEACH",
      hereFeatureId: null,
    },
    {
      id: 1008,
      sicId: defaultMockServiceCenter.id,
      zones: ["South LA County Mid"],
      zoneIds: [],
      zipCodes: ["90240", "90241", "90242"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "DOWNEY",
      hereFeatureId: null,
    },
    {
      id: 1009,
      sicId: defaultMockServiceCenter.id,
      zones: ["North SD County"],
      zoneIds: [],
      zipCodes: ["92025", "92026", "92027", "92029", "92030"],
      startTime: "09:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "ESCONDIDO",
      hereFeatureId: null,
    },
    {
      id: 1010,
      sicId: defaultMockServiceCenter.id,
      zones: ["IE"],
      zoneIds: [],
      zipCodes: ["91701", "91708", "91709", "91710"],
      startTime: "10:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "RANCHO CUCAMONGA",
      hereFeatureId: null,
    },
    {
      id: 1011,
      sicId: defaultMockServiceCenter.id,
      zones: ["North LA County"],
      zoneIds: [],
      zipCodes: ["91301", "91302", "91303"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "CALABASAS",
      hereFeatureId: null,
    },
    {
      id: 1012,
      sicId: defaultMockServiceCenter.id,
      zones: ["OC Inland"],
      zoneIds: [],
      zipCodes: ["92602", "92603", "92604", "92606", "92612", "92614"],
      startTime: "08:00:00",
      endPoint: null,
      endTime: null,
      trailerId: null,
      tractorId: null,
      straightTruckId: null,
      doorId: 0,
      driverId: 0,
      isRoute: true,
      isActive: true,
      name: "IRVINE",
      hereFeatureId: null,
    },
  ],
} as const satisfies Record<string, OldRoute[]>;
